import { EntityApi } from "../Constants/api";
import axiosInstance from "../Utils/axiosInstance";

export const getEntitiesApi = async (params) => {
  try {
    const searchParams = new URLSearchParams(params);
    let response = await axiosInstance.get(
      `${EntityApi}?${searchParams.toString()}`
    );

    return response.data;
  } catch (error) {
    return error.response.data;
    // throw error; // Re-throw error for further handling if needed
  }
};
